import type { PropsWithChildren } from 'react';

import { ThemeContextProvider } from '@/shared/hooks/useTheme';

export function ThemeProvider({ children }: PropsWithChildren<object>) {
  return <ThemeContextProvider>{children}</ThemeContextProvider>;
}
